import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconAlertComponent } from '../../shared/components/icon-alert/icon-alert.component';
import { TranslatePipe } from '@ngx-translate/core';
import { UserContextService } from '../../shared/services/user-context/user-context.service';
import { ButtonComponent } from '../../shared/components';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import { NavigationService } from '@/app/shared/components/navigation/navigation.service';
import { catchError, filter, map, of } from 'rxjs';
import { LoadingSpinnerComponent } from '@/app/shared/components/loading-spinner/loading-spinner.component';
import { StorageService } from '@/app/shared/services/storage/storage.service';
import { match } from 'ts-pattern';

@Component({
  selector: 'dpqa-error-page',
  imports: [CommonModule, IconAlertComponent, ButtonComponent, RouterLink, TranslatePipe, LoadingSpinnerComponent],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.less',
})
export class ErrorPageComponent {
  public readonly userContextService = inject(UserContextService);
  private readonly authService = inject(AuthService);
  private readonly navigationService = inject(NavigationService);
  private readonly storageService = inject(StorageService);

  public errorCode = input.required<('403' | '404')>({ alias: 'error-code' });
  public showTenantSelection = computed(() => {
    const possibleTenants = this.userContextService.possibleTenants();
    const tenantId = this.storageService.get('current_tenant');
    return possibleTenants?.length > 1 ||
      (possibleTenants?.length === 1 && tenantId !== possibleTenants[0]);
  });

  public errorIcon = computed(() => match(this.errorCode())
    .with('403', () => 'no-access')
    .otherwise(() => 'x-circle'));

  public homeRoute$ = this.userContextService.userContext$
    .pipe(
      filter((userContext) => userContext.userPermissions !== undefined),
      map((userContext) => this.navigationService.firstAllowedRoute(userContext.userPermissions!)),
      catchError(() => of({ link: undefined, name: undefined })),
    );

  public handleLogout(): void {
    this.authService.logout();
  }
}
